import React from "react";
import * as Icon from "react-feather";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";

import shareLinkIcon from "../../../assets/images/share-link.png";

import { copyTextToClipboard } from "../../../shared/helpers";
import ModalHolder from "../../molecules/ModalHolder";
import { PrimaryButton } from "../../atoms/Buttons";
import { H3, P } from "../../atoms/Texts";

const ReferralFormShareLinkModal = ({ link = "", closeModal }) => {
  return (
    <ModalHolder width="50%" closeModal={closeModal}>
      <div className="py-20 px-12">
        <img src={shareLinkIcon} alt="" className="h-24 w-24 mx-auto mb-5" />
        <H3 color="#22202D" fontFamily="medium" className="text-center">
          Share link
        </H3>
        <div className="flex justify-between mt-4">
          <div
            className="py-3 pl-5 pr-12 flex-grow mr-5"
            style={{ backgroundColor: "#F8F6FE", border: "1px solid #E5E1F5" }}
          >
            <P fontSize="14px">{link}</P>
          </div>
          <PrimaryButton
            onClick={() => copyTextToClipboard(link)}
            className="whitespace-no-wrap"
          >
            Copy Link
          </PrimaryButton>
        </div>
        <div className="grid grid-cols-3 gap-2 mt-12">
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
            <div
              className="flex items-center justify-center py-4"
              style={{ backgroundColor: "#E4E3EE" }}
            >
              <TwitterShareButton
                url={link}
                className="flex justify-between items-center focus:outline-none"
              >
                <Icon.Twitter size={14} />
                <P fontSize="14px" className="font-semibold pl-2">
                  Share on Twitter
                </P>
              </TwitterShareButton>
            </div>
          </a>
          <div
            className="flex justify-center items-center py-4"
            style={{ backgroundColor: "#E4E3EE" }}
          >
            <LinkedinShareButton
              url={link}
              className="flex justify-between items-center focus:outline-none"
            >
              <Icon.Linkedin size={14} />
              <P fontSize="14px" className="font-semibold pl-2">
                Share on LinkedIn
              </P>
            </LinkedinShareButton>
          </div>
          <div
            className="flex justify-center items-center py-4"
            style={{ backgroundColor: "#E4E3EE" }}
          >
            <FacebookShareButton
              url={link}
              className="flex justify-between items-center"
            >
              <Icon.Facebook size={14} />
              <P fontSize="14px" className="font-semibold pr-1">
                Share on Facebook
              </P>
            </FacebookShareButton>
          </div>
        </div>
      </div>
    </ModalHolder>
  );
};

export default ReferralFormShareLinkModal;
